export class VasttrafikGidHelper {
  public static ServiceJourneyGidPrefix = 9015;
  public static LineGidPrefix = 9011;
  public static MunicipalityGidPrefix = 9081;

  public static getMunicipalityGidFromMunicipalityNumber(municipalityNumber: number): string | undefined {
    return municipalityNumber < 1 || municipalityNumber > 9999 ? undefined : `${this.MunicipalityGidPrefix}01411000${String(municipalityNumber).padStart(4, '0')}`;
  }

  public static getLineGidFromServiceJourneyGid(gid: string): string | undefined {
    if (!this.isValidBaseGid(gid)) return undefined;
    if (!this.isServiceJourneyGid(gid)) return undefined;

    const filler = '00000';
    const temp = this.LineGidPrefix.toString().concat(gid.substr(4));
    return temp.slice(0, 11).concat(filler);
  }

  public static getPublicTransportAuthority(gid: string | undefined): string | undefined {
    if (!gid || !this.isValidBaseGid(gid)) return undefined;
    return gid.substring(4, 7);
  }

  public static isValidBaseGid(gid: string | undefined): boolean {
    if (!gid || Number.isNaN(Number(gid)) || gid.length !== 16) {
      return false;
    }
    return true;
  }

  public static isServiceJourneyGid(gid: string): boolean {
    return this.isValidBaseGid(gid) && Number(gid.slice(0, 4)) === VasttrafikGidHelper.ServiceJourneyGidPrefix;
  }

  public static isMunicipalityGid(gid: string): boolean {
    return this.isValidBaseGid(gid) && Number(gid.slice(0, 4)) === VasttrafikGidHelper.MunicipalityGidPrefix;
  }
}
